import api from './api';
import type { PublicProfileResponse, VendorProfileAnalytics } from '../types';

/** Feature 1 — public profile endpoints. */
export const publicProfileApi = {
  /** GET /api/public/v/:slug/ — Layer 1 (anon) or Layer 2 (auth). */
  getProfile(slug: string) {
    return api.get<PublicProfileResponse>(`/public/v/${slug}/`).then((r) => r.data);
  },

  /** POST /api/public/v/:slug/view/ — record a view (rate-limited). */
  recordView(slug: string) {
    return api.post(`/public/v/${slug}/view/`);
  },

  /** POST /api/public/v/:slug/verification-request/ — buyer asks for L3 access. */
  submitVerificationRequest(
    slug: string,
    body: {
      requester_name: string;
      requester_email: string;
      requester_company?: string;
      relationship?: string;
      message?: string;
    }
  ) {
    return api.post(`/public/v/${slug}/verification-request/`, body);
  },

  /** GET /api/vendor/profile-analytics/ — vendor's own profile analytics. */
  getVendorAnalytics() {
    return api.get<VendorProfileAnalytics>('/vendor/profile-analytics/').then((r) => r.data);
  },
};
